export default __webpack_public_path__ + "static/media/loading.6a11e13b.gif";